import { Controller } from "@hotwired/stimulus";

// Submits the enclosing form when a field fires change — checklist count
// and comment fields persist without a save button. The controller element
// IS the form.
export default class extends Controller {
  static targets = ["changed"];

  // Stamp the field that actually changed. The row posts every field on
  // every autosubmit, so which one the user touched is the only thing that
  // separates "the count box was deliberately emptied" from "the count box
  // happened to be empty while the note was saving" — and the server cannot
  // tell them apart from the payload alone.
  submit(event) {
    if (this.hasChangedTarget) this.changedTarget.value = event?.target?.name ?? "";
    this.element.requestSubmit();
  }
}
